import { render } from "./CardProjectDetail.vue?vue&type=template&id=c4f19910&scoped=true&ts=true"
import script from "./CardProjectDetail.vue?vue&type=script&lang=ts"
export * from "./CardProjectDetail.vue?vue&type=script&lang=ts"

import "./CardProjectDetail.vue?vue&type=style&index=0&id=c4f19910&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f19910"]])

export default __exports__